import { cn } from "@/common/helpers/utils";
import { CarCutterWebPlayerLoading } from "@/components/car-cutter-web-player/car-cutter-web-player-skeleton";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

const TAB_IDS = ["overview", "valuation-history", "relocation-orders", "system-identifiers"];

const INFO_ROW_IDS = Array.from({ length: 11 }, (_, rowIndex) => `info-row-${rowIndex}`);

export function VehicleDetailSkeleton(): ReactElement {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Wide}>
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4">
          <Skeleton className="size-12 shrink-0 rounded-lg" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
      </header>

      <div className="mt-2 flex flex-col gap-6">
        <div className="flex gap-2">
          {TAB_IDS.map((tabId) => (
            <Skeleton key={tabId} className="h-9 w-28" />
          ))}
        </div>

        <div className="grid items-stretch gap-6 xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
          <Card className="min-w-0">
            <CardHeader>
              <div className="flex items-center gap-2">
                <Skeleton className="size-5" />
                <Skeleton className="h-5 w-40" />
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid gap-x-6 gap-y-3 sm:grid-cols-2">
                {INFO_ROW_IDS.map((rowId, rowIndex) => (
                  <div key={rowId} className="flex flex-col gap-1">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className={cn("h-4", rowIndex % 2 === 0 ? "w-40" : "w-28")} />
                  </div>
                ))}
              </div>
              <Skeleton className="mt-3 h-8 w-28" />
            </CardContent>
          </Card>
          <CarCutterWebPlayerLoading />
        </div>
      </div>
    </CenteredLayout>
  );
}
